import { lazy } from "react";
import Loadable from "app/components/Loadable";
import AuthGuard from "app/auth/AuthGuard";

const ChooseAccount = Loadable(lazy(() => import("./ChooseAccount")));
const Loading = Loadable(lazy(() => import("./Loading")));

const sessionRoutes = [
  {
    path: "/choose-account",
    element: (
      <AuthGuard>
        <ChooseAccount />
      </AuthGuard>
    ),
  },
  {
    path: "/loading",
    element: (
      <Loading />
    ),
  },
];

export default sessionRoutes;
